import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPencil: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="pencil, edit, write"><path d="M16.4697 1.96967C16.7626 1.67678 17.2374 1.67678 17.5303 1.96967L22.0303 6.46967C22.3232 6.76256 22.3232 7.23744 22.0303 7.53033L18.8107 10.75L13.25 5.18934L16.4697 1.96967Z" fill="currentColor"/><path d="M12.1893 6.25L2.21967 16.2197C2.07902 16.3603 2 16.5511 2 16.75V21.25C2 21.6642 2.33579 22 2.75 22H7.25C7.44891 22 7.63968 21.921 7.78033 21.7803L17.75 11.8107L12.1893 6.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPencil;
